module.exports = __webpack_public_path__ + "assets/img/info.ae7e0108.svg";